<template>
  <footer class="main-footer px-3" :class="{ isFixed: fixedFooter }">
    <span
      >&copy; {{ new Date().getFullYear() }} Kimberlin Education all rights
      reserved</span
    >

    <a class="logo" href="http://kimberlineducation.com/" target="_blank">
      <img
        src="https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/logo_ke.png"
      />
    </a>
  </footer>
</template>

<script>
export default {
  name: 'DashboardFooter',
  data() {
    return {
      fixedFooter: false
    }
  }
}
</script>

<style lang="scss">
.main-footer {
  width: 100%;
  border-top: 1px solid #f1f1f1;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.08);
  position: relative;

  span {
    line-height: 80px;
    @include breakpoint($xs) {
      line-height: initial;
      margin-top: 15px;
      display: block;
    }
  }

  .logo {
    float: right;
    line-height: 80px;
    @include breakpoint($xs) {
      display: block;
      float: none;
      margin: 15px 0;
      line-height: 45px;
    }
    img {
      display: block;
      margin-top: 20px;
    }
  }
}
</style>
